const splitRoute = require('./split-route');

/**
 * Determine whether a route pattern refers to a dynamic route, rather than a static path
 * @param {RoutePattern|Array<RoutePattern>} routePattern Route pattern to test
 * @return {boolean} Whether the route pattern refers to a dynamic route
 */
function isDynamicRoute(routePattern) {
  return Array.isArray(routePattern) || !splitRoute(routePattern).every((pathSegment) =>
      ((typeof pathSegment === 'string') || (typeof pathSegment === 'number')) &&
      (pathSegment !== '*')
    );
}

module.exports = isDynamicRoute;
